<div>
    <!-- <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Nomination Details</h5> -->
    <div class="row mx-0 mt-4">
        <div class="pe-5 col-md-12">
            <div class="px-0 mb-4">
                <strong>Would you like to add nominee to this Account?<span class="text-danger">*</span></strong>
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <!-- <div class="col">
                        <input class="ms-0 form-check-input" name="nomineeStatus" [(ngModel)]="nominee"
                            (change)="nomineeClick()" type="radio" value="Y" id="nyes">
                        <label class="form-check-label ps-2" for="nyes">Yes, I wish to add nominee</label>
                    </div> -->
                    <div class="col d-flex align-items-start">
                        <input class="ms-0 form-check-input mt-1" name="nomineeStatus" [(ngModel)]="nominee"
                            (change)="nomineeClick()" type="radio" value="Y" id="nyes">

                        <label class="form-check-label ps-2 mb-0" for="nyes" style="margin-top: -4px;">
                            Yes, I wish to add nominee
                        </label>
                    </div>

                    <!-- <div class="col">
                        <input class="ms-md-3 form-check-input" name="nomineeStatus" [(ngModel)]="nominee"
                            (change)="nomineeClick()" type="radio" value="N" id="nno">
                        <label class="form-check-label ps-2" for="nno">No, I do not wish to add nominee</label>
                    </div> -->
                    <div class="col d-flex align-items-start">
                        <input class="ms-md-3 form-check-input mt-1" name="nomineeStatus" [(ngModel)]="nominee"
                            (click)="nomineeNoClick()" type="radio" value="N" id="nno">

                        <label class="form-check-label ps-2 mb-0" for="nno" style="margin-top: -4px;">
                            No, I do not wish to add nominee
                        </label>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div *ngIf="nominee === 'Y'">
        <div class="row mx-0">
            <div class="col-lg-12 pe-5 ">
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <div class="col-12">
                        <strong> Do you want to print name of nominee(s) in your Statement of Account/Holding?<span
                                class="text-danger">*</span></strong>
                    </div>
                    <div class="col ">
                        <input class="form-check-input" type="radio" id="soaYes" name="printNominee"
                            [(ngModel)]="printNominee" value="Y" (change)="SOAChange($event)" />
                        <label class="form-check-label ps-2" for="soaYes">Yes</label>
                    </div>

                    <div class="col ">
                        <input class="ms-md-3 form-check-input" type="radio" id="soaNo" name="printNominee"
                            [(ngModel)]="printNominee" value="N" (change)="SOAChange($event)" />
                        <label class="form-check-label ps-2" for="soaNo">No</label>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="card shadow-sm border-0 mx-md-3 mb-4" *ngFor="let list of nomineeArray; let i = index">
            <nri-app-nominee-info *ngIf="!nomineeGetData" [data]="list" [indexvalue]="i" (shareValue)="shareValueCheck($event)" (nomineeAdd)="nomineeAdd($event)" (nomineeDelete)="nomineeDelete($event)" (nomineeFormValid)="nomineeData($event)"></nri-app-nominee-info>
            <nri-app-nominee-info *ngIf="nomineeGetData" [data]="list" [nomineeGetData]="nomineeGetData[i]" [indexvalue]="i" (shareValue)="shareValueCheck($event)" (nomineeAdd)="nomineeAdd($event)" (nomineeDelete)="nomineeDelete($event)" (nomineeFormValid)="nomineeData($event)"></nri-app-nominee-info>
        </div> -->
        <ng-container *ngFor="let list of nomineeArray; let i = index">
            <nri-app-nominee-info *ngIf="!nomineeGetData" [data]="list" [indexvalue]="i"
                (shareValue)="shareValueCheck($event)" (nomineeAdd)="nomineeAdd($event)"
                (nomineeDelete)="nomineeDelete($event)" (nomineeFormValid)="nomineeData($event)"></nri-app-nominee-info>
            <nri-app-nominee-info *ngIf="nomineeGetData" [data]="list" [nomineeGetData]="nomineeGetData[i]"
                [indexvalue]="i" (shareValue)="shareValueCheck($event)" (nomineeAdd)="nomineeAdd($event)"
                (nomineeDelete)="nomineeDelete($event)" (nomineeFormValid)="nomineeData($event)"></nri-app-nominee-info>
        </ng-container>
    </div>

    <!-- <div class="d-flex align-items-end h-100 mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" (click)="stageValidate()">Next</button>
        </div>
    </div> -->
</div>
<div class="modal fade" id="nnModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-body px-md-5 py-md-4 p-4">
                <h6 class="text-primary fw-bold mb-3">Declaration</h6>
                <p class="small mb-3">
                    I hereby confirm that I do not wish to appoint any nominee(s) to my demat account/trading
                    account at this point of time.
                </p>
                <p class="small mb-2">I understand that &ndash;</p>

                <div class="form-check d-flex align-items-start mb-3">
                    <input class="form-check-input mt-1 flex-shrink-0" type="checkbox"
                        id="optOutCheck1" name="optOutCheck1" [(ngModel)]="optOutCheck1"
                        [ngModelOptions]="{standalone: true}">
                    <label class="form-check-label small ps-2 mb-0" for="optOutCheck1">
                        <strong>(i)</strong> the nomination helps to quickly identify the person for transfer of
                        securities and helps in faster and smoother transmission of my securities to my legal heir(s)
                        after my demise.
                    </label>
                </div>

                <div class="form-check d-flex align-items-start mb-3">
                    <input class="form-check-input mt-1 flex-shrink-0" type="checkbox"
                        id="optOutCheck2" name="optOutCheck2" [(ngModel)]="optOutCheck2"
                        [ngModelOptions]="{standalone: true}">
                    <label class="form-check-label small ps-2 mb-0" for="optOutCheck2">
                        <strong>(ii)</strong> in the absence of a nomination, my legal heir(s) may require the
                        submission of certain additional legal or court-issued documents which may delay the process of
                        transmission of securities to my legal heir(s).
                    </label>
                </div>

                <div class="form-check d-flex align-items-start mb-3">
                    <input class="form-check-input mt-1 flex-shrink-0" type="checkbox"
                        id="optOutCheck3" name="optOutCheck3" [(ngModel)]="optOutCheck3"
                        [ngModelOptions]="{standalone: true}">
                    <label class="form-check-label small ps-2 mb-0" for="optOutCheck3">
                        <strong>(iii)</strong> if no claim is made on the account for a prolonged period after my
                        demise, the holdings may be treated as unclaimed assets and they may be transferred to Investor
                        Education and protection Fund Authority (IEPF) in accordance with the applicable regulatory
                        framework.
                    </label>
                </div>

                <p class="small mb-0">
                    I confirm that I have understood the above implications and that my decision to opt out of
                    nomination is voluntary.
                </p>

                <div class="d-flex align-items-end mx-0 h-100 mt-4 row">
                    <div class="col-6 p-0">
                        <button class="btn btn-white small border-primary text-primary px-4" data-bs-dismiss="modal"
                            (click)="cancelOptOut()">Cancel</button>
                    </div>
                    <div class="col-6 text-end p-0 pe-md-3">
                        <button class="btn btn-primary small px-4" data-bs-dismiss="modal"
                            [disabled]="!(optOutCheck1 && optOutCheck2 && optOutCheck3)"
                            (click)="confirmOptOut()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>